export const DISCUSSION_GROUP_LOCALE = {
    submit: 'Submit',
    cancel: 'Cancel',
    colleague: 'Colleague',
    all: 'For all to see',
    related: 'Relevant personnel can see',
    confirm: 'Confirm',
    reply: 'Reply',
    emptyMessage:'Empty Data',
    placeholder: 'Please input search keywords',
    notEmpty:'The submitted content cannot be empty',
    selectEmployee:'Select the employee',
    next: 'Next',
    emptySelected:'Clear',
    emptyRight:'Select on the left',
    allOrg:'All',
    selected:'Selected',
    section:'Section ',
    people:'Per ',
    viewMore:'View more',
    per:' ',
    pcs:' ',
    emptyList:'Empty contacts',
    advancedQuery:'Select'
};
